
import React from 'react';

const HeroSection: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20technology%20workspace%20with%20sleek%20computers%2C%20holographic%20displays%2C%20and%20futuristic%20digital%20interfaces%20in%20a%20minimalist%20office%20environment%20with%20clean%20lines%2C%20ambient%20lighting%2C%20and%20professional%20atmosphere%20showcasing%20innovation%20and%20cutting-edge%20software%20development&width=1920&height=1080&seq=hero-bg-001&orientation=landscape')`
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white pt-20 md:pt-0">
        <div className="max-w-4xl mx-auto space-y-6 md:space-y-8">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold leading-tight">
            Unlock The Value of Your{' '}
            <span className="text-teal-400">Data</span>{' '}
            Through Intelligent AI Solutions
          </h1>
          
          <p className="text-lg sm:text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed px-4 sm:px-0">
            Antriva helps businesses transform through AI agents, advanced observability, 
            data engineering, and rapid MVP development.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6 md:pt-8 px-4 sm:px-0">
            <button 
              onClick={scrollToContact}
              className="w-full sm:w-auto bg-teal-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-teal-600 transition-all duration-300 transform hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
            >
              Start Your Project
            </button>
            <button 
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="w-full sm:w-auto border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-gray-900 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Explore Services
            </button>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
